import { memo } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Menu } from '@/components/ui/daisy/menu';
import { ShellNavItemProps } from '@/utils/app-shell/getAppShellNavItems';

type ShellSidebarNavItemProps = ShellNavItemProps & {
  isOpen: boolean;
  onNavigate(): void;
};

function ShellSidebarNavItem({
  href,
  activePath,
  icon: Icon,
  label,
  isOpen,
  onNavigate,
}: ShellSidebarNavItemProps) {
  const isActive = !!useMatch(activePath);

  return (
    <Menu.Item
      className={twJoin(!isOpen && 'tooltip tooltip-right')}
      data-tip={isOpen ? undefined : label}
    >
      <Link
        to={href}
        aria-label={label}
        aria-current={isActive ? 'page' : undefined}
        onClick={onNavigate}
        className={twJoin(
          !isOpen && 'justify-center',
          isActive && 'not-active:text-primary',
        )}
      >
        <Icon className="size-6 shrink-0" />
        <ConditionalRenderer condition={isOpen}>
          <span className="whitespace-nowrap">{label}</span>
        </ConditionalRenderer>
      </Link>
    </Menu.Item>
  );
}

export default memo(ShellSidebarNavItem);
